import {Card, Space, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringAnswerType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {AnswerCompetitors} from './answer-competitors';
import {AnswerVerdict} from './answer-verdict';
import * as styles from './answer-card.scss';

type PropsType = {
    answer: AiMonitoringAnswerType;
};

// One prompt and what the model answered about the brand.
export function AnswerCard(props: PropsType): JSX.Element {
    const {answer} = props;

    return (
        <Card className={styles.answer_card} size="small">
            <div className={styles.answer_card__header}>
                <Typography.Text className={styles.answer_card__prompt_label} type="secondary">
                    <Locale stringKey="AI_BRAND_MONITORING__ANSWERS__PROMPT" />
                </Typography.Text>
                <Typography.Text>{answer.promptText}</Typography.Text>
            </div>

            <Space className={styles.answer_card__findings} direction="vertical" size={10}>
                <AnswerVerdict answer={answer} />
                <AnswerCompetitors competitorsMentioned={answer.competitorsMentioned} />
            </Space>
        </Card>
    );
}
